import React from 'react';
import PropTypes from 'prop-types';

import ToolTip from '../../ToolTip/ToolTip';
import timeplanUnitValid from './timeplanUnitValid';
import * as styles from './timeplan.css';
import { TimeplanUnitRecord } from '../../../entities/records';
import { useTranslation } from 'react-i18next';

function Warnings({ showWarnings, overlaps, duplicates, timeplanUnit }) {
  const { t } = useTranslation();
  if (!showWarnings) {
    return null;
  }

  return (
    <div className={styles.timeWarningBox}>
      {overlaps && (
        <ToolTip
          iconClassName={`fa fa-exclamation-circle text-warning ${styles.timeWarning}`}
          title={t("Överlapp")}
        >
          {t("Något av passen överlappar denna dag!")}
        </ToolTip>
      )}
      {duplicates && (
        <ToolTip
          iconClassName={`fa fa-exclamation-circle text-warning ${styles.timeWarning}`}
          title={t("Dublett")}
        >
          {t("Något av passen är en dublett denna dag!")}
        </ToolTip>
      )}
      {!timeplanUnitValid(timeplanUnit) && (
        <ToolTip
          iconClassName={`fa fa-exclamation-circle text-danger ${styles.timeWarning}`}
          title={t("Felaktigt pass")}
        >
          {t("Något av passen är inte komplett denna dag!")}
        </ToolTip>
      )}
    </div>
  );
};

Warnings.propTypes = {
  showWarnings: PropTypes.bool.isRequired,
  timeplanUnit: PropTypes.instanceOf(TimeplanUnitRecord).isRequired,
  overlaps: PropTypes.bool.isRequired,
  duplicates: PropTypes.bool.isRequired,
};

export default Warnings;
